import React from 'react';
import './Map.css'; 
import MapImage from "../../assets/images/map.png"; // Default fallback map image
import resolveMediaUrl from "../../utils/resolveMediaUrl";

const Map = ({ address, mapPath, gameName }) => {
  const normalizedAddress = String(address || "").trim();
  const normalizedGameName = String(gameName || "").trim();
  const mapQuery = [normalizedGameName, normalizedAddress].filter(Boolean).join(", ");
  const hasQuery = mapQuery.length > 0;
  const mapSrc = resolveMediaUrl(mapPath, MapImage);
  const googleMapsUrl = hasQuery
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}`
    : "https://maps.google.com";
  // No paid API required: force place marker view on initial load.
  const googleEmbedUrl = hasQuery
    ? `https://maps.google.com/maps?hl=en&q=${encodeURIComponent(mapQuery)}&t=m&z=17&ie=UTF8&iwloc=A&output=embed`
    : "";

  return (
    <div className="map-container">
      <div className="map-image">
        {googleEmbedUrl ? (
          <div className="map-embed-frame-wrap" aria-label={`${gameName || "stadium"} map preview`}>
            <iframe
              src={googleEmbedUrl}
              className="map-embed-frame"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`Map of ${gameName || "stadium"}`}
            />
          </div>
        ) : (
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="map-image-link"
            aria-label={`Open ${gameName || "stadium"} location in Google Maps`}
          >
            <img src={mapSrc} alt="Map Location" />
          </a>
        )}
      </div>
      <div className="map-info">
        <h3>{gameName}</h3>
        <p><a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">{address}</a></p>
      </div>
    </div>
  );
};

export default Map;
